import { useState } from 'react';
import { useHistory } from 'react-router';

import { CheckIcon } from '../../../../../assets/icons';
import { LetterDelivered } from '../../../../../assets/illustrations';
import { BUTTON_LOOK } from '../../../../../components/atoms/Button';
import Notification, { NOTIFICATION_LOOK } from '../../../../../components/molecules/Notification';
import NoticePage from '../../../../../components/templates/NoticePage/NoticePage';
import { pagePaths } from '../../../config';
import { useCoreTranslation } from '../../../hooks/useCoreTranslation';

import { ResetEmailSentProps } from '.';

import { useSendForgottenEmailMutation } from '@/modules/Core/api/password/passwordApi';

const ResetEmailSent = ({ email }: ResetEmailSentProps) => {
  const history = useHistory();
  const { label } = useCoreTranslation(__filename);
  const [sendForgottenEmail] = useSendForgottenEmailMutation();

  const [isNotificationDisplayed, setNotificationDisplayed] = useState<boolean>(false);

  const notification = (
    <Notification
      title={label('Ref: New email sent')}
      look={NOTIFICATION_LOOK.SUCCESS}
      icon={<CheckIcon />}
    />
  );
  const resendResetEmail = async () => {
    if (email) {
      await sendForgottenEmail({ email });
    }
    setNotificationDisplayed(true);
  };

  const actions = [
    {
      label: label('Go to login page'),
      action: () => history.push(pagePaths.Login),
      look: BUTTON_LOOK.SECONDARY,
    },
    {
      label: label('Resend email'),
      action: () => resendResetEmail(),
      look: BUTTON_LOOK.TERTIARY,
    },
  ];

  return (
    <NoticePage
      img={<LetterDelivered />}
      hideAllWidgets
      withNavBar={false}
      hasBackLink={true}
      title={label('Ref: Email sent title')}
      note={label('Ref: Email sent msg', {
        replace: { email_address: email ?? '' },
      })}
      actions={actions}
      topContent={isNotificationDisplayed && notification}
      tabTitle={label('Ref: TabTitle')}
    />
  );
};

export default ResetEmailSent;
